(function () {
    'use strict';

    angular
        .module('cacmEventEditModule', [
            'services.permission',
            'services.selectionService',
            'gov.directives'
        ]);
})();
